import { useState } from 'react';

interface ParticipantNotificationsProps {
  notificationNumbers: string[];
}

export function ParticipantNotifications({
  notificationNumbers,
}: ParticipantNotificationsProps) {
  const [isRowExpanded, setIsRowExpanded] = useState(false);

  if (isRowExpanded && notificationNumbers.length > 1) {
    return (
      <div className="lowercase">
        {notificationNumbers.map((number, index) => (
          <div key={number}>
            {number}
            {index + 1 === notificationNumbers.length && (
              <span
                className="text-zinc-500 cursor-pointer hover:underline"
                onClick={() => setIsRowExpanded(false)}
              >
                &nbsp;show less
              </span>
            )}
          </div>
        ))}
      </div>
    );
  }

  if (notificationNumbers.length > 1) {
    return (
      <span className="line-clamp-1 lowercase">
        <span>{notificationNumbers[0]}</span>
        <span
          className="text-zinc-500 cursor-pointer hover:underline"
          onClick={() => {
            setIsRowExpanded(!isRowExpanded);
          }}
        >
          &nbsp;and {notificationNumbers.length - 1} more
        </span>
      </span>
    );
  }

  return (
    <span className="line-clamp-1 lowercase">{notificationNumbers[0]}</span>
  );
}
